// Part of the Chili3d Project, under the AGPL-3.0 License.
// See LICENSE file in the project root for full license information.

import { Locale } from "./i18n";

export default {
    display: "日本語",
    code: "ja",
    translation: {
        "arc.angle": "角度",
        "arc.start": "開始点",
        "axis.x": "X軸",
        "axis.y": "Y軸",
        "axis.z": "Z軸",
        "body.arc": "円弧",
        "body.bolean": "ブーリアン",
        "body.box": "ボックス",
        "body.pyramid": "ピラミッド",
        "body.cylinder": "円柱",
        "body.cone": "円錐",
        "body.group": "グループ",
        "body.sphere": "球体",
        "body.ellipse": "楕円",
        "body.circle": "円",
        "body.face": "面",
        "body.fuse": "結合",
        "body.imported": "インポート済み",
        "body.line": "線",
        "body.polygon": "ポリライン",
        "body.prism": "押し出し",
        "body.rect": "長方形",
        "body.revol": "回転",
        "body.sweep": "スイープ",
        "body.wire": "ワイヤー",
        "box.dx": "長さ",
        "box.dy": "幅",
        "box.dz": "高さ",
        "body.editableShape": "編集可能な形状",
        "body.meshNode": "メッシュノード",
        "body.multiShape": "複数形状",
        "circle.center": "中心",
        "circle.radius": "半径",
        "ellipsoid.radiusX": "X半径",
        "ellipsoid.radiusY": "Y半径",
        "ellipsoid.radiusZ": "Z半径",
        "ellipse.majorRadius": "長径",
        "ellipse.minorRadius": "短径",
        "command.act.alignCamera": "カメラ整列",
        "command.boolean.common": "交差",
        "command.boolean.cut": "切断",
        "command.boolean.join": "結合",
        "command.convert.fuse": "結合",
        "command.convert.revol": "回転",
        "command.convert.sweep": "スイープ",
        "command.convert.toFace": "面に変換",
        "command.convert.toShell": "シェルに変換",
        "command.convert.toSolid": "ソリッドに変換",
        "command.convert.toWire": "ワイヤーに変換",
        "command.convert.curveProjection": "投影",
        "command.create.arc": "円弧",
        "command.create.bezier": "ベジェ",
        "command.create.box": "ボックス",
        "command.create.circle": "円",
        "command.create.cone": "円錐",
        "command.create.copyShape": "形状コピー",
        "command.create.cylinder": "円柱",
        "command.create.ellipse": "楕円",
        "command.create.ellipsoid": "楕円体",
        "command.create.extrude": "押し出し",
        "command.create.folder": "フォルダ",
        "command.create.group": "グループ",
        "command.create.line": "線",
        "command.create.offset": "オフセット",
        "command.create.polygon": "ポリライン",
        "command.create.pyramid": "ピラミッド",
        "command.create.rect": "長方形",
        "command.create.section": "断面",
        "command.create.sphere": "球体",
        "command.create.thickSolid": "厚みソリッド",
        "command.doc.new": "新しく模型を作る",
        "command.doc.open": "保存済みファイルを開く",
        "command.doc.save": "模型を保存",
        "command.doc.saveToFile": "ファイルに保存",
        "command.edit.redo": "やり直し",
        "command.edit.undo": "元に戻す",
        "command.file.export": "エクスポート",
        "command.file.import": "インポート",
        "command.file.importCityGML": "CityGMLインポート",
        "command.file.importCityGMLByAddress": "住所からインポート",
        "command.file.importCityGMLByCesium": "Cesium 3D地図から取り込み",
        "command.file.importPlateauBuilding": "PLATEAU建物インポート",
        "command.file.stepUnfold": "展開図",
        "command.file.assemblyMode": "組み立てをする",
        "citygml.defaultHeight": "デフォルト高さ",
        "citygml.buildingLimit": "建物数上限",
        "citygml.autoReproject": "自動再投影",
        "citygml.buildingIds": "建物ID (カンマ区切り)",
        "citygml.filterAttribute": "フィルタ属性",
        "plateau.searchQuery": "住所または施設名",
        "plateau.searchRadius": "検索半径",
        "plateau.buildingLimit": "建物数",
        "plateau.autoReproject": "自動再投影",
        "plateau.mergeBuildingParts": "建物パーツを結合",
        "plateau.cesium.selectCity": "都市を選択",
        "plateau.cesium.clickToSelect": "建物をクリックして選択（Ctrl+クリックで複数選択）",
        "plateau.cesium.selectedCount": "選択中: {0}件",
        "plateau.cesium.importSelected": "選択した建物を取り込む",
        "plateau.cesium.clearSelection": "選択をクリア",
        "plateau.cesium.zoomToSelection": "選択範囲へズーム",
        "plateau.cesium.instructions.click": "建物をクリックして選択",
        "plateau.cesium.instructions.ctrlClick": "Ctrl+クリックで複数選択",
        "plateau.cesium.instructions.clearArea": "空白エリアをクリックでクリア",
        "plateau.cesium.noSelection": "建物が選択されていません",
        "plateau.cesium.clickToSelectBuilding": "建物をクリックして選択してください",
        "plateau.cesium.ctrlClickForMultiple": "複数選択にはCtrlキーを押しながらクリック",
        "plateau.cesium.loading": "読み込み中...",
        "error.plateau.selectAtLeastOne": "少なくとも1つの建物を選択してください",
        "command.measure.angle": "角度",
        "command.measure.length": "長さ",
        "command.measure.select": "選択",
        "command.modify.applyTexture": "テクスチャ適用",
        "command.modify.array": "配列",
        "command.modify.break": "分割",
        "command.modify.brushAdd": "ブラシ追加",
        "command.modify.brushRemove": "ブラシ削除",
        "command.modify.brushClear": "ブラシクリア",
        "command.modify.chamfer": "面取り",
        "command.modify.deleteNode": "ノード削除",
        "command.modify.editTextureRotation": "テクスチャ回転編集",
        "command.modify.explode": "分解",
        "command.modify.fillet": "フィレット",
        "command.modify.mirror": "ミラー",
        "command.modify.move": "移動",
        "command.modify.removeFeature": "フィーチャー削除",
        "command.modify.removeShapes": "形状削除",
        "command.modify.rotate": "回転",
        "command.modify.split": "分割",
        "command.modify.trim": "トリム",
        "command.special.last": "__最後のコマンド__",
        "command.test.performace": "パフォーマンステスト",
        "command.settings.keymap": "キーボードショートカット",
        "command.settings.units": "単位設定",
        "settings.keymap": "キーボードショートカット",
        "settings.keymap.preset": "プリセット",
        "settings.keymap.shortcuts": "ショートカット",
        "settings.keymap.search": "ショートカットを検索...",
        "settings.keymap.export": "エクスポート",
        "settings.keymap.import": "インポート",
        "settings.keymap.reset": "デフォルトに戻す",
        "settings.keymap.noResults": "ショートカットが見つかりません",
        "settings.keymap.resetConfirm": "デフォルトのキーボードショートカットに戻してもよろしいですか？",
        "texture.selection.title": "テクスチャー選択",
        "texture.pattern": "パターン",
        "texture.preview": "プレビュー",
        "texture.tileCount": "タイル数",
        "command.wechat.group": "WeChat",
        "command.workingPlane.alignToPlane": "整列",
        "command.workingPlane.fromSection": "断面",
        "command.workingPlane.set": "設定",
        "command.workingPlane.toggleDynamic": "切り替え",
        "common.angle": "角度",
        "common.area": "面積",
        "common.back": "戻る",
        "common.language": "言語",
        "common.3DNavigation": "3Dナビゲーション",
        "common.cancel": "キャンセル",
        "common.clone": "複製",
        "common.color": "色",
        "common.confirm": "確認",
        "common.general": "一般",
        "common.length": "長さ",
        "common.dir": "方向",
        "common.material": "マテリアル",
        "common.matrix": "行列",
        "common.name": "名前",
        "common.normal": "法線",
        "common.opacity": "不透明度",
        "common.thickness": "厚さ",
        "common.type": "タイプ",
        "common.volume": "体積",
        "dialog.title.selectWorkingPlane": "作業平面を選択",
        "entity.editable": "編集可能エンティティ",
        "entity.parameter": "パラメータエンティティ",
        "error.default:{0}": "エラー: {0}",
        "error.input.cannotInputANumber": "参照点と重複しています。1つの数値を入力できません",
        "error.input.invalidNumber": "有効な数値を入力してください。カンマで区切ってください",
        "error.input.threeNumberCanBeInput": "参照点が空です。3つの数値のみ入力できます",
        "error.input.unsupportedInputs": "最大入力数を超えています",
        "error.import.unsupportedFileType:{0}": "サポートされていないファイルタイプ: {0}",
        "error.import.notCityGML": "有効なCityGMLファイルではありません",
        "error.import.invalidFileExtension": "CityGMLファイル（.gml、.xml）のみがサポートされています",
        "error.citygml.conversionFailed:{0}": "CityGML変換に失敗しました: {0}",
        "error.citygml.importFailed:{0}": "CityGMLインポートに失敗しました: {0}",
        "error.plateau.emptyQuery": "住所または施設名を入力してください",
        "error.plateau.emptyMeshCode": "メッシュコードを入力してください",
        "error.plateau.searchFailed:{0}": "建物の検索に失敗しました: {0}",
        "error.plateau.noBuildingsFound:{0}": "建物が見つかりませんでした: {0}",
        "error.plateau.conversionFailed:{0}": "STEP変換に失敗しました: {0}",
        "error.plateau.importFailed:{0}": "PLATEAUインポートに失敗しました: {0}",
        "error.plateau.notABuilding": "建物を選択してください",
        "error.plateau.noGmlId": "建物IDを取得できませんでした",
        "error.plateau.cityNotFound:{0}": "都市が見つかりません: {0}",
        "error.plateau.cityLoadFailed:{0}:{1}": "{0}の読み込みに失敗しました: {1}",
        "error.plateau.selectionFailed:{0}": "建物の選択に失敗しました: {0}",
        "error.plateau.cesiumInitFailed:{0}": "Cesiumの初期化に失敗しました: {0}",
        "error.plateau.outOfBounds": "日本国内の座標のみサポートしています",
        "error.plateau.waterArea": "海上には建物データがありません",
        "error.plateau.dataNotAvailable": "この地域のPLATEAUデータは未整備です",
        "error.plateau.invalidMeshCode": "メッシュコードは8桁の数字で入力してください",
        "error.plateau.buildingNotFound": "指定された建物IDが見つかりませんでした",
        "error.plateau.emptyBuildingId": "建物IDを入力してください",
        "error.export.noNodeCanBeExported": "エクスポート可能なノードがありません",
        "error.textureService.notFound": "FaceTextureServiceが見つかりません",
        "error.faceNumber.notFound": "面番号を取得できませんでした",
        "error.texture.notApplied": "選択した面にテクスチャが適用されていません",
        "error.geometryNode.notFound": "ジオメトリノードが見つかりません",
        "file.format": "フォーマット",
        "home.recent": "最近作成した模型",
        "home.welcome": "Paper CADへようこそ",
        "home.createFromAddress": "建物名・住所から模型を作成",
        "items.header": "アイテム",
        "items.tool.delete": "削除",
        "items.tool.expandAll": "すべて展開",
        "items.tool.newFolder": "新規フォルダ",
        "items.tool.unexpandAll": "すべて折りたたむ",
        "line.end": "終点",
        "line.start": "始点",
        "line.type.line": "線",
        "line.type.xline": "構築線",
        "material.texture.image": "画像",
        "material.texture.rotation": "回転",
        "material.texture.wrapS": "ラップS",
        "material.texture.wrapT": "ラップT",
        "material.texture.repeat": "繰り返し",
        "material.texture.offset": "オフセット",
        "material.map": "マップ",
        "material.specular": "スペキュラー",
        "material.shininess": "光沢",
        "material.emissive": "発光",
        "material.specularMap": "スペキュラーマップ",
        "material.normalMap": "法線マップ",
        "material.bumpMap": "バンプマップ",
        "material.roughnessMap": "粗さマップ",
        "material.emissiveMap": "発光マップ",
        "material.metalness": "金属度",
        "material.metalnessMap": "金属度マップ",
        "material.roughness": "粗さ",
        "model.visible": "表示",
        "option.command.repeat": "繰り返し",
        "option.command.isFace": "面",
        "option.command.isRoundCorner": "角丸",
        "option.command.thickness": "厚さ",
        "option.command.isConnected": "接続",
        "option.command.isConvertInstance": "インスタンス変換",
        "option.command.insertPoint": "挿入点",
        "polygon.points": "ポイント",
        "prompt.default{0}{1}": "{0}でビューを移動、{1}でビューを回転、マウスホイールでズーム",
        "prompt.deleteDocument{0}": "{0}を削除しますか？",
        "prompt.pickCircleCenter": "中心を選択、ESCキーでキャンセル",
        "prompt.pickFistPoint": "最初の点を選択、ESCキーでキャンセル",
        "prompt.pickNextPoint": "次の点を選択、ESCキーでキャンセル",
        "prompt.pickRadius": "半径を入力、ESCキーでキャンセル",
        "prompt.polygon.close": "閉じる",
        "prompt.saveDocument{0}": "{0}への変更を保存しますか？",
        "prompt.select.edges": "エッジを選択してください",
        "prompt.select.faces": "面を選択してください",
        "prompt.selectFacesForTexture": "テクスチャを適用する面をクリックしてください",
        "prompt.selectTexturedFace": "テクスチャが適用されている面を選択",
        "prompt.select.models": "展開する3D形状を選択してください",
        "prompt.select.noModelSelected": "モデルが選択されていません",
        "prompt.select.section": "断面を選択してください",
        "prompt.select.shape": "形状を選択してください",
        "prompt.select.solids": "ソリッドを選択してください",
        "prompt.select.path": "パスを選択してください",
        "prompt.select.vertexes": "頂点を選択してください",
        "prompt.select.wires": "ワイヤーを選択してください",
        "toast.snap.notFoundValidPoint": "有効な点が見つかりません",
        "properties.group.transform": "変換",
        "properties.header": "プロパティ",
        "properties.multivalue": "複数値",
        "rect.dx": "長さ",
        "rect.dy": "幅",
        "ribbon.group.2d": "2D",
        "ribbon.group.3d": "3D",
        "ribbon.group.act": "アクション",
        "ribbon.group.boolean": "ブーリアン",
        "ribbon.group.brush": "ブラシ",
        "ribbon.group.converter": "コンバーター",
        "ribbon.group.draw": "描画",
        "ribbon.group.edit": "編集",
        "ribbon.group.importExport": "インポート/エクスポート",
        "ribbon.group.measure": "測定",
        "ribbon.group.modify": "修正",
        "ribbon.group.other": "その他",
        "ribbon.group.selection": "選択",
        "ribbon.group.tools": "ツール",
        "ribbon.group.transform": "変形",
        "ribbon.group.workingPlane": "作業平面",
        "ribbon.tab.converter": "コンバーター",
        "ribbon.tab.draw": "描画",
        "ribbon.tab.file": "ファイル",
        "ribbon.tab.modify": "修正",
        "ribbon.tab.tools": "ツール",
        "ribbon.tab.startup": "スタートアップ",
        "snap.center": "中心",
        "snap.end": "端点",
        "snap.intersection": "交点",
        "snap.mid": "中点",
        "snap.perpendicular": "垂直",
        "snap.nearest": "近接点",
        "statusBar.snap": "スナップ",
        "statusBar.tracking": "トラッキング",
        "texture.patternId": "パターン",
        "unit.millimeter": "ミリメートル",
        "unit.centimeter": "センチメートル",
        "unit.meter": "メートル",
        "unit.inch": "インチ",
        "unit.foot": "フィート",
        "unit.degree": "度",
        "unit.radian": "ラジアン",
        "unit.lengthUnit": "長さ単位",
        "unit.angleUnit": "角度単位",
        "unit.lengthPrecision": "長さ精度",
        "unit.anglePrecision": "角度精度",
        "unit.settings": "単位設定",
        "toast.command.{0}excuting": "コマンド {0} を実行中",
        "toast.converter.error": "コンバーターエラー",
        "toast.converter.invalidColor": "無効な色です",
        "toast.delete{0}Objects": "{0}個のオブジェクトを削除しました",
        "toast.document.noActivated": "アクティブな模型がありません",
        "toast.document.saved": "模型を保存しました",
        "toast.downloading": "ダウンロード中",
        "toast.excuting{0}": "{0}を実行中",
        "toast.fail": "失敗",
        "toast.read.error": "読み込みエラー",
        "toast.select.noSelected": "選択されていません",
        "toast.success": "成功",
        "toast.citygml.converting": "CityGMLを3Dモデルに変換中...",
        "toast.citygml.importSuccess": "CityGMLインポートに成功しました",
        "toast.plateau.searching": "PLATEAUデータを検索中...",
        "toast.plateau.converting:{0}": "{0}件の建物を3Dモデルに変換中...",
        "toast.plateau.importSuccess:{0}:{1}m": "{0} を {1}m 地点からインポートしました",
        "toast.plateau.allConversionsFailed:{0}": "全ての変換に失敗しました。失敗した建物: {0}",
        "toast.plateau.cesiumImportSuccess:{0}": "Cesiumから{0}件の建物を取り込みました",
        "toast.plateau.cesiumImportSuccessWithFailures:{0}:{1}:{2}":
            "Cesiumから{0}件の建物を取り込みました（{1}件失敗: {2}）",
        "toast.plateau.cesiumImportFailed:{0}": "Cesiumからの取り込みに失敗しました: {0}",
        "toast.plateau.importSuccess:{0}": "{0}件の建物を取り込みました",
        "toast.plateau.importSuccessWithFailures:{0}:{1}:{2}":
            "{0}件の建物を取り込みました（{1}件失敗: {2}）",
        "toast.plateau.importFailed:{0}": "建物の取り込みに失敗しました: {0}",
        "toast.plateau.tilesetLoadFailed:{0}": "一部のメッシュ読み込みに失敗しました（{0}件）",
        "toast.stepUnfold.success": "展開図を生成しました",
        "toast.stepUnfold.error": "展開図の生成に失敗しました",
        "stepUnfold.scale": "縮尺",
        "stepUnfold.scale.label": "縮尺: 1/{0}",
        "stepUnfold.modelSize": "想定模型サイズ: 最大 {0}mm",
        "stepUnfold.experimental": "🧪 実験的機能",
        "stepUnfold.experimentalWarning": "この機能は実験段階です。正確性を保証するものではありません。",
        "stepUnfold.layoutMode": "レイアウトモード",
        "stepUnfold.layoutMode.canvas": "キャンバス",
        "stepUnfold.layoutMode.paged": "ページ分割",
        "stepUnfold.pageFormat": "ページフォーマット",
        "stepUnfold.pageFormat.A4": "A4",
        "stepUnfold.pageFormat.A3": "A3",
        "stepUnfold.pageFormat.Letter": "レター",
        "stepUnfold.pageOrientation": "向き",
        "stepUnfold.pageOrientation.portrait": "縦",
        "stepUnfold.pageOrientation.landscape": "横",
        "assembly.title": "組み立てモード",
        "assembly.close": "閉じる",
        "assembly.helpText": "面番号を入力、または展開図・3Dモデルの面をクリックしてハイライトできます",
        "assembly.3dModel": "3Dモデル",
        "assembly.2dUnfold": "2D展開図",
        "assembly.status": "ステータス",
        "assembly.ready": "準備完了",
        "assembly.selectedFace": "選択面",
        "assembly.faceCount": "面数",
        "assembly.faceNumberInput": "面番号",
        "assembly.enterFaceNumber": "面番号を入力（例: 1）",
        "assembly.highlight": "ハイライト",
        "assembly.clearSelection": "クリア",
        "assembly.reset3DView": "3Dビューをリセット",
        "assembly.reset2DView": "2Dビューをリセット",
        "assembly.zoomIn": "拡大",
        "assembly.zoomOut": "縮小",
        "assembly.loadingModel": "3Dモデルを読み込み中...",
        "assembly.loadingUnfold": "展開図を生成中...",
        "assembly.faceSelected:{0}": "面 {0} を選択中",
        "assembly.shortcutHint": "ショートカット: Enterでハイライト / Escで終了",
        "toast.assemblyMode.started": "組み立てモードを開始しました",
        "toast.assemblyMode.error": "組み立てモードの開始に失敗しました",
        "toast.assemblyMode.unfoldError": "展開図の生成に失敗しました",
        "toast.assemblyMode.closed": "組み立てモードを終了しました",
        "toast.assemblyMode.invalidFaceNumber": "有効な面番号を入力してください（1以上）",
        "toast.assemblyMode.faceNotFound:{0}": "面 {0} が見つかりません",
        "toast.texture.rotationSet:{0}": "テクスチャの回転を {0}° に設定しました",
        "transform.rotation": "回転",
        "transform.scale": "スケール",
        "transform.translation": "移動",
        "vertex.point": "点",
    },
} satisfies Locale;
